export const HEADER_HEIGHT = 128
export const FOOTER_HEIGHT = 64
